import React from 'react';

// Subtle decorative leaf SVGs (top-left and top-right corners)
export function LeafTopLeft({ className = '' }) {
  return (
    <svg
      viewBox="0 0 220 200"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMinYMin meet"
    >
      <defs>
        <linearGradient id="leafGrad1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#3d8b6e" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#1f5a4d" stopOpacity="0.85" />
        </linearGradient>
      </defs>
      <g fill="url(#leafGrad1)">
        <path d="M-20,-20 C30,10 70,40 90,90 C70,80 40,70 10,70 C-10,40 -20,10 -20,-20 Z" />
        <path d="M-10,40 C25,55 55,80 70,120 C50,110 25,105 0,105 C-10,80 -15,60 -10,40 Z" opacity="0.75" />
        <path d="M50,-15 C75,15 95,45 100,80 C82,72 60,65 40,65 C30,40 35,10 50,-15 Z" opacity="0.6" />
      </g>
    </svg>
  );
}

export function LeafTopRight({ className = '' }) {
  return (
    <svg
      viewBox="0 0 220 200"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMaxYMin meet"
    >
      <defs>
        <linearGradient id="leafGrad2" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3d8b6e" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#1f5a4d" stopOpacity="0.85" />
        </linearGradient>
      </defs>
      <g fill="url(#leafGrad2)">
        <path d="M240,-20 C190,10 150,40 130,90 C150,80 180,70 210,70 C230,40 240,10 240,-20 Z" />
        <path d="M230,40 C195,55 165,80 150,120 C170,110 195,105 220,105 C230,80 235,60 230,40 Z" opacity="0.75" />
        <path d="M170,-15 C145,15 125,45 120,80 C138,72 160,65 180,65 C190,40 185,10 170,-15 Z" opacity="0.6" />
      </g>
    </svg>
  );
}

export function LeafBottomLeft({ className = '' }) {
  return (
    <svg
      viewBox="0 0 220 200"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMinYMax meet"
    >
      <defs>
        <linearGradient id="leafGrad3" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#3d8b6e" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#1f5a4d" stopOpacity="0.85" />
        </linearGradient>
      </defs>
      <g fill="url(#leafGrad3)">
        <path d="M-20,220 C30,190 70,160 90,110 C70,120 40,130 10,130 C-10,160 -20,190 -20,220 Z" />
        <path d="M-10,160 C25,145 55,120 70,80 C50,90 25,95 0,95 C-10,120 -15,140 -10,160 Z" opacity="0.7" />
      </g>
    </svg>
  );
}

export function LeafBottomRight({ className = '' }) {
  return (
    <svg
      viewBox="0 0 220 200"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMaxYMax meet"
    >
      <defs>
        <linearGradient id="leafGrad4" x1="1" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#3d8b6e" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#1f5a4d" stopOpacity="0.85" />
        </linearGradient>
      </defs>
      <g fill="url(#leafGrad4)">
        <path d="M240,220 C190,190 150,160 130,110 C150,120 180,130 210,130 C230,160 240,190 240,220 Z" />
        <path d="M230,160 C195,145 165,120 150,80 C170,90 195,95 220,95 C230,120 235,140 230,160 Z" opacity="0.7" />
      </g>
    </svg>
  );
}
